export default __webpack_public_path__ + "static/media/15-2.da0adb2e.mp3";